// models
import { Base } from 'app/shared/models/base.model';
import { User } from 'app/shared/models/user.model';
import { OrderService } from 'app/shared/models/order-service.model';
import { ContactCustomer } from 'app/shared/models/contact-customer.model';

export class Budget extends Base {

  constructor(
    public Code?: string,
    public CustomerContact?: ContactCustomer,
    public FinalValue?: number,
    public OrderService?: OrderService,
    public Responsible?: User,
    public SendDate?: Date,
  ) {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/budgets/shared/budgets.model.ts